import { message } from 'antd'
import { EmployeeLoanApi } from '../../../../api/People/EmployeeLoan'
import PaymentSchedule from '../../../../components/People/EmployeeLoan/Lines/PaymentSchedule'
import React from 'react'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import useModalData from '../../../../elements/Hooks/useModalData'

function PaymentScheduleCont (props) {
  const { employeeLoan } = props
  const { list, fetching, fetch } = useFetchList(() =>
    EmployeeLoanApi.getPayLine(employeeLoan._key),
  )

  const {
    visible,
    modalType,
    object: line,
    submitting,
    setSubmitting,
    removing,
    remove,
    formRef,
    onShow,
    onCancel,
    checkForm,
    update,
  } = useModalData(
    undefined,
    EmployeeLoanApi.lines.update,
    EmployeeLoanApi.lines.remove,
    fetch,
  )

  async function submit () {
    const newObject = await checkForm()
    setSubmitting(true)
    try {
      await EmployeeLoanApi.lines.create({
        ...newObject,
        loan: { _id: employeeLoan._id }, // it will be change in backend to order
      })
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  return (
    <PaymentSchedule
      {...{
        list,
        fetching,
        fetch,
        visible,
        submitting,
        employeeLoan,
        line,
        onShow,
        onCancel,
        submit,
        removing,
        remove,
        update,
        modalType,
        formRef,
      }}
    />
  )
}

PaymentScheduleCont.propTypes = {}
PaymentScheduleCont.defaultProps = {}

export default (PaymentScheduleCont)
